import ManageDidPoolController from './controller/ManageDidPoolController.js'
import template from './manageDidPool.component.tpl.pug'

const manageDidPool = {
  template: template(),
  controller: ManageDidPoolController,
}

export default manageDidPool
